import(/* webpackMode: "eager" */ "/tmp/8df39e0fb51e52b/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-bailout-to-csr.js");
;
import(/* webpackMode: "eager" */ "/tmp/8df39e0fb51e52b/node_modules/next/dist/shared/lib/lazy-dynamic/preload-css.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/tmp/8df39e0fb51e52b/src/app/metrics.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/tmp/8df39e0fb51e52b/src/components/ClientInit/ClientInit.tsx");
;
import(/* webpackMode: "eager" */ "/tmp/8df39e0fb51e52b/src/providers/index.tsx");
;
import(/* webpackMode: "eager" */ "/tmp/8df39e0fb51e52b/src/styles/global.scss");
